.waitlistModalContainer .ant-modal-content {
  /* Main body background color and rounded corners */
  background-color: #f7f7f7; /* Light gray background */
  border-radius: 16px; /* Rounded corners for the entire modal */
  overflow: hidden;
  padding: 0;
}

/* Inner padding and layout */
.waitlistModalContent {
  /* padding: 24px; */
  display: flex;
  flex-direction: column;
  gap: 16px; /* Spacing between sections */
}

/* Modal Title */
.modalTitle {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 18px;
  color: #04051b; /* Dark text color */
}

/* Modal Subtitle/Description */
.modalSubtitle {
  font-size: 1rem;
  color: #525252; /* Slightly lighter text color */
  margin: 0;
  font-weight: 400;
}

/* Email Label */
.inputLabel {
  font-size: 12px;
  font-weight: 500;
  color: #04051b;
  display: block;
  margin-top: 0; /* Space above the label */
}

/* Email Input - Custom styling to match the image */
.emailInputCustom {
  height: 48px; /* Taller input field */
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
  padding: 0 12px;
}

/* Radio Card Wrapper for horizontal layout */
.radioOptionsSpace {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}

/* Individual Radio Card Style */
.radioCard {
  flex: 1; /* Makes both cards equal width */
  padding: 12px;
  border-radius: 10px;
  cursor: pointer;
  background-color: #fafafa; /* White background for the card */
  border: 1px solid #fafafa;
  transition: all 0.2s ease-in-out;
}
.radioCard :global(.ant-radio-wrapper .ant-radio) {
  align-self: self-start !important;
  top: 2px;
}
/* Radio Card Hover/Selected State */
.radioCard:hover {
  border-color: #ffba42;
}

.selected {
  background-color: #fef5e7;
  border-color: #ffba42;
}
.selected :global(.ant-radio-wrapper .ant-radio-checked .ant-radio-inner) {
  border-color: #ffba42;
  background-color: #ffba42;
}
.radioCard :global(.ant-radio-wrapper:hover .ant-radio-inner) {
  border-color: #ffba42;
}
/* Hide the default Antd Radio border/ring when clicked */

.radioCustom {
  width: 100%;
}

/* Content within the Radio Card */
.radioContent {
  display: flex;
  flex-direction: column;
  margin-left: 8px; /* Space between the radio button and the text */
}

.radioLabel {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
}

.radioDescription {
  font-size: 12px;
  color: #777;
  margin-top: 4px;
}

/* Join Button Style */
.joinButtonCustom {
  height: 52px; /* Large button height */
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  width: 100%; /* Full width button */
  margin-top: 8px;
  background-color: #ffa100; /* Custom gray color from the image */
  border-color: #ffa100;
  color: #04051b;
}

.joinButtonCustom:disabled {
  background-color: #e5e5e5 !important;
  border-color: #e5e5e5 !important;
  color: #737373 !important;
}

/* Customizing the placement of the close icon */
.waitlistModalContainer .ant-modal-close {
  top: 24px;
  right: 24px;
  width: auto;
  height: auto;
  color: #333; /* Dark color for the X icon */
}

@media (max-width: 575.98px) {
  .modalTitle {
    font-size: 18px;
  }
  .modalSubtitle {
    font-size: 12px;
  }
  .waitlistModalContainer :global(.ant-modal-container) {
    padding: 24px 16px;
  }
  .radioContent {
    margin-left: 0;
  }
  .waitlistModalContainer :global(.ant-radio-label) {
    padding-inline-end: 0 !important;
  }
}
